import React, { Suspense } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';

interface OnboardingStepActionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

function ModalLoadingFallback() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-600" aria-hidden />
    </div>
  );
}

export function OnboardingStepActionModal({
  open,
  onOpenChange,
  title,
  children,
}: OnboardingStepActionModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[min(92vh,900px)] w-[calc(100vw-1rem)] max-w-6xl flex-col gap-0 overflow-hidden p-0 sm:w-full">
        <DialogHeader className="shrink-0 space-y-0 border-b border-border px-4 pb-4 pt-2 text-left sm:px-6 sm:pb-4 sm:pt-3">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-6">
          <Suspense fallback={<ModalLoadingFallback />}>{children}</Suspense>
        </div>
      </DialogContent>
    </Dialog>
  );
}
